"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteSearch;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _searchBar = _interopRequireDefault(require("./search-bar"));
var _flyout = _interopRequireDefault(require("./flyout"));
var _siteSearchContext = require("../site-search-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */
/* eslint-disable max-len */

const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-weyh2m6",
  vars: {
    "weyh2m6-1": [({
      isOpen
    }) => isOpen ? Math.max(_patternLibraryUtils.knownZIndexes.primaryNav) + 1 : '1']
  }
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-cl15o0s"
});
const Curtain = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Curtain",
  class: "pl-c12txsoq"
});
function SiteSearch({
  _name,
  id,
  placeholder,
  clearAriaLabel,
  popularListLabel,
  suggestionsListLabel,
  resultsListLabel,
  noResultsListLabel,
  trackingV2 = false
}) {
  const {
    autocomplete,
    handleOnConfirm,
    step,
    setStep,
    value,
    setValue,
    list,
    setList,
    suggestedList,
    isActive,
    setIsActive
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const [selectedItemIndex, setSelectedItemIndex] = (0, _react.useState)(-1);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const steps = {
    initial: popularListLabel,
    suggestions: suggestionsListLabel,
    results: resultsListLabel,
    noResults: noResultsListLabel
  };
  const handleOnChange = (0, _react.useCallback)((searchTerm, abortController) => {
    if (!isActive) setIsActive(true);
    setValue(searchTerm);
    const searchTermTrimmed = searchTerm.trim();
    if (searchTermTrimmed?.length === 0) {
      setStep('initial');
      setList(suggestedList);
    } else if (searchTermTrimmed?.length > 0 && step !== 'suggestions') {
      setStep('suggestions');
      if (list === suggestedList) {
        setList([]);
        setIsLoading(true);
      }
    }
    if (searchTermTrimmed?.length >= 2) {
      const tm = setTimeout(() => {
        const keyword = searchTermTrimmed.toLowerCase();
        autocomplete(keyword, () => setIsLoading(false), abortController);
      }, 300);
      return () => clearTimeout(tm);
    }
  }, [autocomplete, isActive, list, setIsActive, setList, setStep, setValue, step, suggestedList]);
  function handleKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
        {
          event.preventDefault();
          const nextIndex = selectedItemIndex - 1;
          if (nextIndex >= 0) {
            setSelectedItemIndex(nextIndex);
          }
          break;
        }
      case 'ArrowDown':
        {
          event.preventDefault();
          const nextIndex = selectedItemIndex + 1;
          if (nextIndex < list.length) {
            setSelectedItemIndex(nextIndex);
          }
          break;
        }
      case 'Enter':
        {
          event.preventDefault();
          const item = list[selectedItemIndex];
          if (item) {
            handleOnConfirm(item);
            setSelectedItemIndex(-1);
          }
          break;
        }
      default:
        break;
    }
  }
  const handleOnFocus = () => {
    setIsActive(true);
    if (value.length >= 2) {
      setStep('suggestions');
    } else if (value.length === 0) {
      setStep('initial');
      setList(suggestedList);
    }
  };
  (0, _react.useEffect)(() => {
    const abortController = new AbortController();
    const handlePopState = () => {
      if (typeof window !== 'undefined') {
        const url = new URL(window.location);
        const newValue = url.searchParams.get('q') || '';
        const keywordLowerCase = newValue.trim().toLowerCase();
        handleOnChange(keywordLowerCase, abortController);
        handleOnConfirm(keywordLowerCase, {
          type: 'popstate'
        }, abortController);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      abortController.abort();
      window.removeEventListener('popstate', handlePopState);
    };
  }, [handleOnChange, handleOnConfirm]);
  (0, _react.useEffect)(() => {
    const input = document.querySelector('#site-search-input');
    if (isActive) {
      input.focus();
    } else {
      input.blur();
    }
  }, [isActive]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "site-search",
    "data-partial": "precheck"
  }, /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
    id: `wrapper-${id}`,
    "data-cy": "wrapper"
  }, _patternLibraryUtils.tracking.create(`${_name}_tray`, false, false)), /*#__PURE__*/_react.default.createElement(Curtain, {
    "data-cy": "curtain",
    "data-show": isActive
  }), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_searchBar.default, {
    _name: _name,
    id: id,
    placeholder: placeholder,
    clearAriaLabel: clearAriaLabel,
    value: value,
    handleOnFocus: handleOnFocus,
    handleOnBlur: () => setIsActive(false),
    handleKeyDown: handleKeyDown,
    handleOnChange: handleOnChange
  }), /*#__PURE__*/_react.default.createElement(_flyout.default, {
    label: steps[step],
    isLoading: isLoading,
    trackingV2: trackingV2
  }))));
}
SiteSearch.propTypes = {
  _name: _propTypes.default.string,
  ..._searchBar.default.propTypes,
  triggerAriaLabel: _propTypes.default.string,
  searchText: _propTypes.default.string,
  trackingV2: _propTypes.default.bool
};